var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatDissapointed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85986 13.57V8.95H11.6699V3.75H15.4199V0H19.0799V3.55H21.9899V9.15H24.7899V13.57H7.85986Z",
    fill: "#C5E7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6299 13.57V8.95H45.4399V3.75H49.1899V0H52.8499V3.55H55.7599V9.15H58.5599V13.57H41.6299Z",
    fill: "#C5E7F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.02 13.57V11.26H14.93V8.66H16.81V6.78H18.63V8.56H20.09V11.36H21.49V13.57H13.02Z",
    fill: "#DC70E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6802 13.57V11.26H48.5902V8.66H50.4602V6.78H52.2902V8.56H53.7502V11.36H55.1502V13.57H46.6802Z",
    fill: "#DC70E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.23 23.38V20.38H62.97V13.57H6.64V20.38H3.33V23.38H0V62.09H3.33V65.2H6.64V68.74H9.98V72.3H60.59V69.81H63.45V65.2H67.23V62.09H70.56V23.38H67.23Z",
    fill: "#C5E7F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8299 40.42H48.3999V42.95H56.8299V40.42Z",
    fill: "#0086AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 40.42H20.5698V42.95H28.9998V40.42Z",
    fill: "#0086AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2798 49.08H42.8998V51.28H40.0298V53.65H38.0398V51.36H35.2798V49.08Z",
    fill: "#DC70E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6799 58.66H35.1099V61.23H37.6799V58.66Z",
    fill: "#0086AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2502 56.09H37.6802V58.66H40.2502V56.09Z",
    fill: "#0086AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8298 58.66H40.2598V61.23H42.8298V58.66Z",
    fill: "#0086AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatDissapointed);
export default __webpack_public_path__ + "static/media/cat_dissapointed.2517164bdff9c98e6a25d0e500198e2d.svg";
export { ForwardRef as ReactComponent };